import React from 'react';
import PropTypes from 'prop-types';
import LineItemContent from './LineItemContent';
import Loading from '../../Loading/Loading';

import './LineItem.scss';

const LineItem = props => {
  if (props.isLoading) {
    return <Loading dark relative small />;
  }
  return (
    <div className="line-item-content-wrapper">
      <LineItemContent {...props} />
    </div>
  );
};

LineItem.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/LineItem/LineItem.js